import { space } from "postcss/lib/list";
import React from "react";
const SearchComponent = ({
  accountType,
  handleChange,
  handleLeadTypeChange,
  leadType,
  setFilterByObj,
  filterByObj,
}) => {
  return (
    <div
      className="col-sm-4 mt-3"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <div className="">
        <label>Search Here</label>
        <input
          type="search"
          className="form-control"
          placeholder="Search..."
          aria-controls="example1"
          onChange={(e) => {
            setFilterByObj({
              ...filterByObj,
              search: e.target.value,
            });
          }}
          style={{ border: "1px Solid #8E3E63", width: "300px" }}
        />
      </div>
      <div className="px-1">
        <label htmlFor="accountType" className="block mb-2">
          Acc. Type
        </label>
        <select
          id="accountType"
          value={accountType}
          onChange={handleChange}
          className="border p-2 rounded"
        >
          <option value="">Select</option>
          <option value="B2B">B2B</option>
          <option value="B2C">B2C</option>
        </select>
      </div>
      <div className="">
        <label htmlFor="leadType" className="block mb-2">
          Lead Type
        </label>
        <select
          id="leadType"
          value={leadType}
          onChange={handleLeadTypeChange}
          className="border p-2 rounded"
        >
          <option value="">Select</option>
          <option value="Hot">Hot</option>
          <option value="Warm">Warm</option>
          <option value="Cold">Cold</option>
        </select>
      </div>
    </div>
  );
};
export default SearchComponent;
